export default __webpack_public_path__ + "static/media/c5455ea4f0f593e6.a273059c566a7146ec7929898c051add.svg";